import zh from '@/locales/zh';
import en from '@/locales/en';

const locales = {
    zh: zh,
    en: en,
};

export default locales;
